import clsx from "clsx";
import React from "react";

import { CompanySiteType } from "../../../types/company-site";
import { Icon, IconProps } from "../../icon";

export interface StoreIconProps extends Omit<IconProps, "icon"> {
  type: CompanySiteType;
}
export function StoreIcon({ type, className, ...rest }: StoreIconProps) {
  return (
    <Icon
      icon="biesse-pin"
      size={48}
      className={clsx(type === CompanySiteType.Dealer ? "text-dark" : "text-primary", className)}
      {...rest}
    />
  );
}
